import { PlusCircleOutlineIcon } from './PlusCircleOutlineIcon';

/**
 * author: Google
 * id EFB8C700-D60B-4995-B8DE-F3A3E2DA75F3
 * name plus-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-circle-outline.svg
 * tags
 */
export const CirclesAddIcon = PlusCircleOutlineIcon;
export default CirclesAddIcon